import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from '@yme/assets/icons';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { noop } from '@yme/utils/common';
import { ARROW_STATE, DEFAULT_ACTIVE_PER_PAGE_VALUE, DIRECTION_NEXT, DIRECTION_PREV, } from './constants';
import { buildPaginationDesktopConfig, buildPaginationMobileConfig } from './helpers';
export function usePaginationConfig({ paginationData, isMobileView, }) {
    const [activeItemValue, setActiveItemValue] = useState(paginationData.currentPage);
    const defaultPerPageValue = paginationData?.activeElement ||
        (paginationData?.perPageOptions && paginationData.perPageOptions[0]) ||
        DEFAULT_ACTIVE_PER_PAGE_VALUE;
    useEffect(() => {
        if (paginationData?.activeElement && paginationData?.isPageValueReset) {
            setActiveItemValue(1);
        }
    }, [paginationData?.activeElement, paginationData?.isPageValueReset]);
    const [currentPerPageValue, setCurrentPerPageValue] = useState(defaultPerPageValue);
    const onClickArrowButton = ({ direction }) => {
        if (direction === DIRECTION_PREV) {
            return setActiveItemValue(activeItemValue - 1);
        }
        if (direction === DIRECTION_NEXT) {
            return setActiveItemValue(activeItemValue + 1);
        }
        return noop;
    };
    const onClickItemHandler = ({ item, isDisabled, isActiveItem }) => {
        if (item?.type === ARROW_STATE && !isDisabled && item?.onClick) {
            return item.onClick();
        }
        if (!item?.type && !isActiveItem && item?.value && !isDisabled) {
            return setActiveItemValue(item.value);
        }
        return noop;
    };
    const bucketItems = Object.entries(paginationData.items);
    const bucketCount = bucketItems.length;
    const defaultLastItem = bucketCount ? Number(bucketItems[bucketCount - 1][0]) + 1 : bucketItems;
    const isFirstItemDisabled = activeItemValue === 1;
    const isLastItemDisabled = activeItemValue === defaultLastItem;
    const { firstItem, secondItem, thirdItem, fourthItem, fifthItem, sixthItem, seventhItem } = buildPaginationDesktopConfig({
        items: bucketItems,
        activeItemValue,
    });
    const { firstItemMobile, secondItemMobile, thirdItemMobile, fourthItemMobile, fifthItemMobile } = buildPaginationMobileConfig({
        items: bucketItems,
        activeItemValue,
    });
    const paginationBodyItems = isMobileView
        ? [
            {
                ...firstItemMobile,
            },
            {
                ...secondItemMobile,
            },
            {
                ...thirdItemMobile,
            },
            {
                ...fourthItemMobile,
            },
            {
                ...fifthItemMobile,
            },
        ]
        : [
            {
                ...firstItem,
            },
            {
                ...secondItem,
            },
            {
                ...thirdItem,
            },
            {
                ...fourthItem,
            },
            {
                ...fifthItem,
            },
            {
                ...sixthItem,
            },
            {
                ...seventhItem,
            },
        ];
    // Config for Pagination
    const paginationConfig = [
        {
            type: ARROW_STATE,
            isDisabled: isFirstItemDisabled,
            direction: DIRECTION_PREV,
            onClick: () => !isFirstItemDisabled &&
                onClickArrowButton({
                    direction: DIRECTION_PREV,
                } || noop),
            children: React.createElement(SVGIcon, { type: ChevronLeft }),
        },
        ...paginationBodyItems,
        {
            type: ARROW_STATE,
            isDisabled: isLastItemDisabled,
            direction: DIRECTION_NEXT,
            onClick: () => !isLastItemDisabled &&
                onClickArrowButton({
                    direction: DIRECTION_NEXT,
                } || noop),
            children: React.createElement(SVGIcon, { type: ChevronRight }),
        },
    ];
    useEffect(() => {
        if (paginationData?.currentPage) {
            setActiveItemValue(paginationData.currentPage);
        }
    }, [paginationData.currentPage]);
    return {
        paginationConfig,
        activeItemValue,
        onClickItemHandler,
        currentPerPageValue,
        setCurrentPerPageValue,
        setActiveItemValue,
    };
}
